export const RecallCardSkeleton = () => {
  return (
    <div className="bg-card rounded-lg border-l-4 border-l-muted p-3 space-y-2.5 animate-pulse">
      <div className="flex gap-3">
        {/* Image skeleton */}
        <div className="shrink-0 w-16 h-16 rounded-md bg-muted" />
        
        <div className="flex-1 space-y-2">
          {/* Badges skeleton */}
          <div className="flex gap-2">
            <div className="h-5 w-20 bg-muted rounded" />
            <div className="h-5 w-16 bg-muted rounded" />
          </div>
          
          {/* Title skeleton */}
          <div className="space-y-1">
            <div className="h-4 w-3/4 bg-muted rounded" />
            <div className="h-3 w-1/2 bg-muted rounded" />
          </div>
        </div>
      </div>
      
      {/* Retailers skeleton */}
      <div className="flex gap-1">
        <div className="h-5 w-16 bg-muted rounded-full" />
        <div className="h-5 w-20 bg-muted rounded-full" />
      </div>
      
      {/* Footer skeleton */}
      <div className="flex items-center justify-between">
        <div className="h-6 w-32 bg-muted rounded" />
        <div className="h-4 w-12 bg-muted rounded" />
      </div>
    </div>
  );
};
